import React from 'react';

const SUIT_COLORS = {
  "♠": "black", "♣": "black", "♥": "red", "♦": "red"
};

export default function Card({
  card,
  onClick,
  onDragStart,
  onDragEnd,
  onTouchStart,
  onTouchEnd,
  selected = false,
  disabled = false,
  cardSize = 1,
  draggable = false,
  shake = false,
  ghost = false,
}) {
  const w = Math.round(60 * cardSize);
  const h = Math.round(84 * cardSize);
  const fontSize = Math.round(18 * cardSize);
  const suitSize = Math.round(14 * cardSize);
  const centerSize = Math.round(36 * cardSize);

  const baseStyle = {
    width: w + "px",
    height: h + "px",
    borderRadius: Math.round(6 * cardSize) + "px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    padding: Math.round(5 * cardSize) + "px",
    cursor: disabled ? "default" : draggable ? "grab" : "pointer",
    userSelect: "none",
    position: "relative",
    boxShadow: selected ? "0 8px 20px rgba(201,168,76,0.7)" : "0 2px 8px rgba(0,0,0,0.5)",
    outline: selected ? "2px solid #c9a84c" : "none",
    transform: selected ? "translateY(-8px)" : "none",
    animation: shake ? "shake 0.3s ease" : "none",
    transition: "transform 0.15s ease, box-shadow 0.15s ease",
    flexShrink: 0,
    opacity: ghost ? 0.4 : 1,
    WebkitTouchCallout: "none",
    WebkitUserSelect: "none",
  };

  if (!card || !card.faceUp) {
    return (
      <div
        style={{
          ...baseStyle,
          background: "repeating-linear-gradient(45deg, #1a472a, #1a472a 5px, #0d2b18 5px, #0d2b18 10px)",
          border: "2px solid #c9a84c",
          cursor: draggable && !disabled ? "grab" : "default",
        }}
        draggable={draggable && !disabled}
        onDragStart={onDragStart}
        onDragEnd={onDragEnd}
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
        onClick={disabled ? undefined : onClick}
      />
    );
  }

  const isRed = SUIT_COLORS[card.suit] === "red";
  const suitColor = isRed ? "#cc0000" : "#111111";

  return (
    <div
      style={{ ...baseStyle, backgroundColor: "#faf7f0", border: "1px solid rgba(0,0,0,0.15)" }}
      onClick={disabled ? undefined : onClick}
      onTouchEnd={disabled ? undefined : () => { onClick && onClick(); }}
      draggable={draggable && !disabled}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      onTouchStart={onTouchStart}
    >
      {/* Top left - value and suit */}
      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", lineHeight: 1, color: suitColor }}>
        <span style={{ fontSize: fontSize + "px", fontWeight: "900", lineHeight: 1 }}>{card.value}</span>
        <span style={{ fontSize: suitSize + "px", lineHeight: 1.2 }}>{card.suit}</span>
      </div>

      {/* Center suit - large */}
      <div style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -40%)",
        fontSize: centerSize + "px",
        color: suitColor,
        opacity: 0.2,
        lineHeight: 1,
      }}>
        {card.suit}
      </div>
    </div>
  );
}
